import { formValidationBuilder } from 'app/forms/utils/formValidationBuilder'

export const formFields = {
  referrerId: 'referrerId',
  applyToAllTeamMembers: 'applyToAllTeamMembers',
}

const fieldValidation = (fieldName, val) => {
  switch (fieldName) {
    case formFields.applyToAllTeamMembers: {
      return {}
    }
    default:
      return {}
  }
}

export const formValidation = formValidationBuilder(fieldValidation)
